import { Accordion, NumberInput, Select } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';
import type { SuiteForm } from './form';

export function ExecutionOptionsSection({
  form,
  allowSelectRetryBehavior,
  testSuiteIsLoading = false,
}: {
  form: SuiteForm;
  allowSelectRetryBehavior: boolean;
  testSuiteIsLoading?: boolean;
}) {
  return (
    <Accordion.Item value="execution">
      <Accordion.Control icon={<IconSettings size={14} />}>Execution Options</Accordion.Control>
      <Accordion.Panel>
        <div className="grid grid-cols-2 gap-4 xl:gap-x-10">
          {!!allowSelectRetryBehavior && (
            <Select
              label="Retry Behavior"
              description="Retry tests only on failure or for every execution"
              disabled={testSuiteIsLoading}
              data={[
                { value: 'true', label: 'Only retry on failure' },
                { value: 'false', label: 'Always retry (even for success)' },
              ]}
              {...form.getInputProps('retryOnFailure')}
            />
          )}
          <NumberInput
            label="Individual Test Retries"
            description="Control # retries attempted"
            disabled={testSuiteIsLoading}
            allowNegative={false}
            {...form.getInputProps('maxRetries')}
          />
          <NumberInput
            label="Action Delay"
            description="Add delay between actions (ms)"
            disabled={testSuiteIsLoading}
            allowNegative={false}
            {...form.getInputProps('operationDelayMs')}
          />
          <NumberInput
            label="Test Timeout"
            description="Set the maximum time a test can run (s). Leave empty to use default (1200 seconds / 20 minutes)"
            placeholder="1200 (default)"
            disabled={testSuiteIsLoading}
            allowNegative={false}
            min={1}
            // 2 hours
            max={2 * 3600}
            {...form.getInputProps('testTimeoutSeconds')}
          />
        </div>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
